import "./LuxurySection.css";
import GuestImg from "/Home/autopilot.png"; // replace with your actual chat image
import BusinessImg from "/Home/dashboard.png"; // replace with actual dashboard image
import SectionHeader from "../Sections/SectionHeader";


export default function LuxurySection() {
  return (
    <section className="luxury-section">
      {/* === Headings === */}

      <SectionHeader
  title={`Luxury, Reimagined<br />Through Automation.`}
  subtitle={`We build intelligent systems that elevate every moment — from guest check-in to post-stay feedback.`}
/>

      {/* === Cards === */}
      <div className="luxury-grid">
        {/* === Guests === */}
        <div className="luxury-card luxury-card1">
          <div className="card-left">
            <h3>For Guests</h3>
            <p>Your stay, your way<br />Simplified through <span className="highlight">AI Squared Agents.</span></p>
            <ul>
              <li>Check in, order room service, or book a table directly on <strong>WhatsApp</strong></li>
              <li>Receive <strong>personalized recommendations</strong> and <strong>VIP recognition</strong></li>
              <li>Enjoy <strong>instant service</strong>, feedback collection, and tailored offers</li>
            </ul>
            <button className="menu-btn">Explore Dashboard</button>
          </div>
          <div className="card-right">
            <img src={GuestImg} alt="AI Squared Hotel Concierge" className="luxury-img" />
          </div>
        </div>

        {/* === Businesses === */}
        <div className="luxury-card luxury-card2">
          <div className="card-left">
            <h3>For Businesses</h3>
            <p>Empower your brand with <span className="highlight">Luxury Intelligence</span> that listens, learns, and acts.</p>
            <ul>
              <li><strong>Unified dashboards</strong> for all automations and analytics</li>
              <li><strong>Real-time coordination</strong> between agents and staff</li>
              <li><strong>Predictive insights</strong> from guest data integrated with PMS & CRM</li>
            </ul>
            <button className="menu-btn">Explore Dashboard</button>
          </div>
          <div className="card-right">
            <img src={BusinessImg} alt="AI Squared Dashboard" className="luxury-img dashboard-img" />
          </div>
        </div>
      </div>
    </section>
  );
}
